import React from "react";
import Layout from "@/components/Layout";
import usePageMeta from "@/hooks/use-page-meta";
import ContactSection from "@/components/sections/ContactSection";

export default function ContactPage() {
  usePageMeta("Contact KinFlex Home Healthcare — Book Appointment", "Contact KinFlex Home Healthcare. Call 8796465422, WhatsApp us, or send a message. 24×7 emergency support across Delhi NCR.");
  return (
    <Layout>
      <section className="pt-32 pb-6 md:pt-40 md:pb-12 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <div className="eyebrow mb-4">Contact Us</div>
          <h1 className="font-display font-bold text-slate-900 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            We'd love to <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">hear from you</span>.
          </h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">Call, WhatsApp, or drop us a message — we reach back within minutes.</p>
        </div>
      </section>
      <ContactSection heading="Reach Us" subheading="Multiple ways to connect." compact />
    </Layout>
  );
}
